import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";

const UserProfileFields = ({
  formData,
  errors,
  onChange,
  resetPassword,
  onResetPasswordClick,
}) => (
  <>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Name *"
        type="text"
        name="name"
        value={formData.name}
        onChange={onChange}
        placeholder="Enter your Name"
      />
      <span className="error">{errors.name}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Prefix"
        type="text"
        name="prefix"
        value={formData.prefix}
        onChange={onChange}
        placeholder="Enter your Prefix"
      />
      <span className="error">{errors.prefix}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Email ID *"
        type="email"
        name="email"
        value={formData.email}
        onChange={onChange}
        placeholder="Enter your Email"
      />
      <span className="error">{errors.email}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <div style={{ display: "flex", gap: "12px", alignItems: "flex-end" }}>
        <div style={{ flex: 1 }}>
          <TextInput
            title="Password"
            type="password"
            name="password"
            value={resetPassword ? formData.password : "********"}
            onChange={onChange}
            placeholder={resetPassword ? "Enter new password" : "********"}
            disabled={!resetPassword}
          />
        </div>
        <Buttons
          text={resetPassword ? "Cancel" : "Reset"}
          type="button"
          variant="primary"
          onClick={onResetPasswordClick}
          style={{ width: "90px", height: "42px", flexShrink: 0 }}
        />
      </div>
      <span className="error">{errors.password}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Phone Number"
        type="number"
        name="mobileNumber"
        value={formData.mobileNumber}
        onChange={onChange}
        placeholder="Enter your Phone Number"
        maxLength={16}
      />
      <span className="error">{errors.mobileNumber}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Position"
        type="text"
        name="position"
        value={formData.position}
        onChange={onChange}
        placeholder="Enter your Position"
      />
      <span className="error">{errors.position}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="Workplace"
        type="text"
        name="workplace"
        value={formData.workplace}
        onChange={onChange}
        placeholder="Enter your Workplace"
      />
      <span className="error">{errors.workplace}</span>
    </div>
    <div className="main2_profileform_container_section_input">
      <TextInput
        title="No of Users"
        type="number"
        name="numberOfUsers"
        value={formData.numberOfUsers}
        onChange={onChange}
        placeholder="Enter Number Of Users"
        disabled
      />
      <span className="error">{errors.numberOfUsers}</span>
    </div>
    <div className="main2_profileform_container_section_right">
      <label htmlFor="description">Description</label>
      <textarea
        id="description"
        title="Description"
        type="text"
        name="description"
        value={formData.description}
        onChange={onChange}
        placeholder="Enter your Description"
        rows={4}
        style={{ maxHeight: "60px", resize: "none" }}
      />
      <span className="error">{errors.description}</span>
    </div>
  </>
);

export default UserProfileFields;
